<template>
    <v-card :class="{['bg-inner']: true, alerta}" :elevation="$$_elevacao">
      <v-card-title>
        <titulo-questao :numero="numero" :nome="detalhe.foqnome" :obrigatorio="detalhe.foqobrigatorio === 'S'" />
      </v-card-title>
      <v-card-subtitle>
        {{detalhe.foqdescricao}}
      </v-card-subtitle>

      <v-card-text>
        <div v-if="itens.length" class="ol-file__grade">
          <div v-for="item in itens" :key="item.index" class="ol-file__item">
            <button
              type="button"
              class="ol-file__abrir"
              :aria-label="`Ver ${item.nome}`"
              @click="previewIndex = item.index"
            >
              <img v-if="item.tipo === 'imagem'" :src="item.url" alt="">
              <video
                v-else-if="item.tipo === 'video'"
                :src="`${item.url}#t=0.1`"
                muted
                playsinline
                preload="metadata"
              ></video>
              <span v-else class="ol-file__doc">
                <v-icon large color="blue-grey">{{ $$_iconeDocumento(item.nome) }}</v-icon>
              </span>
            </button>
            <span v-if="item.tipo === 'video'" class="ol-file__badge">
              <v-icon x-small color="white">mdi-play</v-icon>
              {{ item.duracao != null ? $$_formatarTempo(item.duracao) : 'vídeo' }}
            </span>
            <span class="ol-file__nome">{{ item.nome }}</span>
            <button
              type="button"
              class="ol-file__remover"
              :aria-label="`Remover ${item.nome}`"
              @click="$_removeArquivo(item.index)"
            >
              <v-icon small color="white">mdi-close</v-icon>
            </button>
          </div>
        </div>

        <div class="ol-file__barra">
          <v-btn
            color="green"
            class="white--text"
            depressed
            small
            :loading="processando"
            @click="sheet = true"
          >
            <v-icon left small>mdi-paperclip</v-icon>
            Anexar
          </v-btn>
          <span class="ol-file__contagem">
            {{ itens.length ? `${itens.length} ${itens.length === 1 ? 'anexo' : 'anexos'}` : 'Nenhum anexo' }}
          </span>
        </div>

        <div v-if="cameraIndisponivel" class="ol-file__info">
          <span>{{ cameraIndisponivel.mensagem }} Use a câmera do sistema; o arquivo volta para esta pergunta.</span>
          <div class="ol-file__info-acoes">
            <v-btn text small @click="cameraIndisponivel = null">Fechar</v-btn>
            <v-btn depressed small color="blue-grey" dark @click="$_cameraNativa('foto')">
              <v-icon left small>mdi-camera</v-icon>Foto
            </v-btn>
            <v-btn depressed small color="blue-grey" dark @click="$_cameraNativa('video')">
              <v-icon left small>mdi-video</v-icon>Vídeo
            </v-btn>
            <v-btn depressed small color="blue-grey" dark @click="$_cameraNativa('galeria')">
              <v-icon left small>mdi-image-multiple</v-icon>Galeria
            </v-btn>
          </div>
        </div>

        <!-- arquivo recusado (tipo, 10 MB ou 5 minutos) -->
        <div v-if="localMessage" class="compact-message">
          {{ localMessage }}
        </div>

        <input ref="galeria" class="ol-file__input" type="file" accept="image/*,video/*" multiple
          @change="$_arquivosSelecionados($event, 'galeria')">
        <input ref="documento" class="ol-file__input" type="file" :accept="acceptDocumento" multiple
          @change="$_arquivosSelecionados($event, 'documento')">
        <!-- fallback sem getUserMedia (HTTP, permissão negada): câmera nativa do aparelho.
             Origem 'camera' para também gerar a cópia no aparelho. -->
        <input ref="fotoNativa" class="ol-file__input" type="file" accept="image/*" capture="environment"
          @change="$_arquivosSelecionados($event, 'camera')">
        <input ref="videoNativo" class="ol-file__input" type="file" accept="video/*" capture="environment"
          @change="$_arquivosSelecionados($event, 'camera')">

      <template v-if="(detalhe && detalhe.subquestoes && detalhe.subquestoes.length > 0) && !complemento">
        <template v-for="(subitem, index) in detalhe.subquestoes">
          <div :key="subitem.id">
            <v-divider></v-divider>
            <component
            :is="componenteCard(subitem.foqtipo)"
            :key="subitem.id"
            :ref="`subquestao-${index + 1}`"
            :detalhe="subitem"
            :complemento="true"
            >
            </component>
          </div>
        </template>
      </template>
      </v-card-text>

      <v-bottom-sheet v-model="sheet">
        <div class="ol-file__sheet">
          <div class="ol-file__sheet-titulo">
            <span>Anexar em "{{ detalhe.foqnome }}"</span>
            <v-icon color="white">mdi-paperclip</v-icon>
          </div>
          <button type="button" class="ol-file__opcao" @click="$_opcao('camera')">
            <span class="ol-file__opcao-icone"><v-icon color="white">mdi-camera</v-icon></span>
            <span>Câmera<small>Foto, vídeo (até 5 min) e galeria do aparelho</small></span>
          </button>
          <button type="button" class="ol-file__opcao" @click="$_opcao('documento')">
            <span class="ol-file__opcao-icone ol-file__opcao-icone--doc"><v-icon color="white">mdi-file-document-outline</v-icon></span>
            <span>Documento<small>PDF, Word, Excel ou texto</small></span>
          </button>
          <div class="ol-file__sheet-acoes">
            <v-btn text @click="sheet = false">Cancelar</v-btn>
          </div>
        </div>
      </v-bottom-sheet>

      <camera-captura
        v-model="camera"
        :modo-inicial="modoCamera"
        :titulo="detalhe.foqnome"
        :anexados="itens.length"
        :nomes-existentes="nomesExistentes"
        @anexar="(item) => $_nomesConfirmados([item])"
        @indisponivel="$_onCameraIndisponivel"
      />

      <midia-nomear
        v-model="nomear"
        :itens="pendentes"
        :nomes-existentes="nomesExistentes"
        @confirmar="$_nomesConfirmados"
        @descartar="$_descartarPendentes"
      />

      <midia-preview
        :value="!!itemPreview"
        :item="itemPreview"
        @input="(aberto) => { if (!aberto) previewIndex = null; }"
        @remover="$_removeArquivo(previewIndex)"
      />
    </v-card>

</template>

<script>
import errorHandler from '../../utils/error-handler';
import { componenteCard } from '../../utils/tipo-card';
import TituloQuestao from '../TituloQuestao.vue';
import {
  ACCEPT_DOCUMENTO, extensao, formatarTempo, mimeBase, prepararArquivo,
  salvarCopia, temCameraWeb, tipoMidia,
} from '../../utils/midia';
import CameraCaptura from '../midia/CameraCaptura.vue';
import MidiaNomear from '../midia/MidiaNomear.vue';
import MidiaPreview from '../midia/MidiaPreview.vue';

export default {
  name: 'card-file',

  components: {
    TituloQuestao,
    CameraCaptura,
    MidiaNomear,
    MidiaPreview,
  },

  inject: {
    // Objeto reativo (ver Checklist.vue `provide()`) — não desestruturar,
    // senão perde a reatividade se a prop `api` do Checklist mudar em runtime.
    checklistBaseURL: { default: () => ({ baseURL: '', copiaGaleria: true }) },
  },

  data() {
    return {
      // Contrato lido pelo Checklist (_data.value): File = arquivo novo,
      // string = nome do arquivo já no servidor, null = arquivo do servidor removido
      // (mantém a posição alinhada com os ids de resposta no update).
      value: [],
      alerta: false,
      linkArquivos: [],
      localMessage: null,
      acceptDocumento: ACCEPT_DOCUMENTO,

      sheet: false,
      camera: false,
      modoCamera: 'foto',
      cameraIndisponivel: null,
      processando: false,
      pendentes: [],
      nomear: false,
      previewIndex: null,
    };
  },

  computed: {
    $$_elevacao() {
      return (this.$props.complemento) ? 5 : 0;
    },
    itens() {
      return (Array.isArray(this.value) ? this.value : [])
        .map((arquivo, index) => ({ arquivo, index }))
        .filter(({ arquivo }) => arquivo != null && arquivo !== '')
        .map(({ arquivo, index }) => {
          if (typeof arquivo === 'string') {
            return {
              index,
              servidor: true,
              nome: arquivo,
              url: this.linkArquivos[index],
              tipo: tipoMidia('', arquivo),
            };
          }
          return {
            index,
            servidor: false,
            nome: arquivo.name,
            url: this.$_url(arquivo),
            tipo: tipoMidia(arquivo.type, arquivo.name),
            tamanho: arquivo.size,
            duracao: this.$_duracoes.get(arquivo),
          };
        });
    },
    nomesExistentes() {
      return this.itens.map((item) => item.nome);
    },
    itemPreview() {
      if (this.previewIndex == null) return null;
      return this.itens.find((item) => item.index === this.previewIndex) || null;
    },
  },

  methods: {
    componenteCard,
    $$_formatarTempo: formatarTempo,

    $$_iconeDocumento(nome) {
      const ext = extensao(nome);
      if (ext === 'pdf') return 'mdi-file-pdf-box';
      if (['doc', 'docx', 'odt'].includes(ext)) return 'mdi-file-word-box';
      if (['xls', 'xlsx', 'ods'].includes(ext)) return 'mdi-file-excel-box';
      return 'mdi-file-document-outline';
    },

    // URL de miniatura por File, criada uma vez e revogada ao remover/destruir.
    $_url(file) {
      if (typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') return '';
      if (!this.$_urls.has(file)) this.$_urls.set(file, URL.createObjectURL(file));
      return this.$_urls.get(file);
    },

    $_revogar(url) {
      if (url && typeof URL !== 'undefined' && typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(url);
    },

    // O .click() dos inputs precisa acontecer dentro do toque do usuário, por isso
    // é síncrono aqui (depois de um await o navegador bloqueia o seletor).
    $_opcao(opcao) {
      this.sheet = false;
      this.localMessage = null;
      if (opcao === 'documento') {
        this.$refs.documento.click();
      } else if (!temCameraWeb()) {
        // Sem câmera no navegador (HTTP): oferece câmera do sistema e galeria.
        this.cameraIndisponivel = { mensagem: 'Este navegador não dá acesso à câmera.' };
      } else {
        // Foto, vídeo e galeria ficam todos dentro da câmera.
        this.cameraIndisponivel = null;
        this.modoCamera = 'foto';
        this.camera = true;
      }
    },

    $_cameraNativa(modo) {
      this.cameraIndisponivel = null;
      if (modo === 'video') this.$refs.videoNativo.click();
      else if (modo === 'galeria') this.$refs.galeria.click();
      else this.$refs.fotoNativa.click();
    },

    $_onCameraIndisponivel({ mensagem }) {
      this.camera = false;
      this.cameraIndisponivel = { mensagem };
    },

    async $_arquivosSelecionados(ev, origem) {
      const files = Array.from((ev.target && ev.target.files) || []);
      // eslint-disable-next-line no-param-reassign
      if (ev.target) ev.target.value = '';
      if (!files.length) return;

      this.processando = true;
      const pendentes = [];
      const recusados = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const f of files) {
        // eslint-disable-next-line no-await-in-loop
        const r = await prepararArquivo(f);
        if (r.ok) {
          pendentes.push({
            file: r.file, tipo: r.tipo, duracao: r.duracao, origem, url: this.$_urlTemporaria(r.file),
          });
        } else {
          recusados.push(r.motivo);
        }
      }
      this.processando = false;

      if (recusados.length) {
        [this.localMessage] = recusados;
        errorHandler(recusados.join(' · '));
      }
      if (pendentes.length) this.$_paraNomear(pendentes);
    },

    $_urlTemporaria(file) {
      if (typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') return '';
      return URL.createObjectURL(file);
    },

    // Todo arquivo passa pelo diálogo de nome antes de entrar na resposta.
    $_paraNomear(itens) {
      if (!itens || !itens.length) return;
      this.pendentes = itens;
      this.nomear = true;
    },

    $_descartarPendentes() {
      this.pendentes.forEach((p) => this.$_revogar(p.url));
      this.pendentes = [];
      this.nomear = false;
    },

    $_nomesConfirmados(lista) {
      const copiar = this.checklistBaseURL.copiaGaleria !== false;
      let atraso = 0;
      lista.forEach((it) => {
        const file = new File([it.file], it.nome, { type: mimeBase(it.file.type) || it.file.type });
        if (it.duracao != null) this.$_duracoes.set(file, it.duracao);
        this.value.push(file);
        this.linkArquivos.push(null);
        // Só o que saiu da câmera: o que veio da galeria já está no aparelho.
        // Espaçado porque o navegador bloqueia vários downloads no mesmo instante.
        if (copiar && it.origem === 'camera') {
          setTimeout(() => salvarCopia(file), atraso);
          atraso += 600;
        }
      });
      this.$_descartarPendentes();
      this.localMessage = null;
    },

    $_alerta() {
      this.alerta = true;
      errorHandler(`${this.$props.detalhe.foqnome} é obrigatória!`);
    },

    $_removeArquivo(index) {
      if (index == null || !Array.isArray(this.value)) return;
      const arquivo = this.value[index];
      this.previewIndex = null;

      if (typeof arquivo === 'string') {
        // Arquivo do servidor: vira null para o update saber qual resposta apagar.
        this.$set(this.value, index, null);
        while (this.linkArquivos.length <= index) this.linkArquivos.push(null);
        this.$set(this.linkArquivos, index, null);
        return;
      }

      // Arquivo novo: sai da lista. Os novos ficam sempre depois dos do servidor,
      // então o splice não desalinha as posições que o update usa.
      if (arquivo && this.$_urls.has(arquivo)) {
        this.$_revogar(this.$_urls.get(arquivo));
        this.$_urls.delete(arquivo);
      }
      this.value.splice(index, 1);
      if (this.linkArquivos.length > index) this.linkArquivos.splice(index, 1);
    },
  },

  props: {
    // Ordem da questão no formulário (ex.: "1-2"), calculada pelo Checklist.
    // Subquestões (complemento) não recebem.
    numero: {
      type: String,
      default: null,
    },
    detalhe: Object,
    complemento: {
      type: Boolean,
      default: false,
    },
    showMessages: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    // Fora do data(): não precisam ser reativos e guardam objetos File como chave.
    this.$_urls = new Map();
    this.$_duracoes = new WeakMap();
  },

  mounted() {
    if (this.detalhe && this.detalhe.resposta && this.detalhe.resposta.length > 0) {
      this.value = this.detalhe.resposta.map((res) => res && res.forresposta).filter(Boolean);
      this.linkArquivos = this.detalhe.resposta.map((res) => `${this.checklistBaseURL.baseURL}/formulario/uploads/respostas/${this.detalhe.foqidformularionuvem}/${this.detalhe.id}/${res.forresposta}`);
    } else {
      this.value = [];
      this.linkArquivos = [];
    }
  },

  beforeDestroy() {
    this.$_urls.forEach((url) => this.$_revogar(url));
    this.$_urls.clear();
    this.pendentes.forEach((p) => this.$_revogar(p.url));
  },

  watch: {
    value(valor) {
      if (valor && valor.some((v) => v != null)) this.alerta = false;
    },
  },
};
</script>

<style scoped>
  .bg-inner {
    width: 100%;
    background-color: #ffffff;
    border-radius: 15px;
    margin-top: 25px;
  }

  .obrigatorio {
    color: red;
    padding-left: 5px;
  }

  .alerta {
    border: 1px solid red;
    animation: vibracao 0.5s;
  }

  @keyframes vibracao {
    0% { transform: translateX(10px); }
    25% { transform: translateX(-10px); }
    50% { transform: translateX(10px); }
    75% { transform: translateX(-10px); }
    100% { transform: translateX(0px); }
  }

.ol-file__grade {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}

/* Mesma linguagem dos cards da visita técnica: borda e faixa verdes. */
.ol-file__item {
  position: relative;
  padding-top: 100%;
  border: 2px solid #4caf50;
  border-radius: 8px;
  overflow: hidden;
  background: #eceff1;
}

.ol-file__abrir {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  display: block;
}

.ol-file__abrir img,
.ol-file__abrir video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  display: block;
}

.ol-file__doc {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-bottom: 18px;
}

.ol-file__badge {
  position: absolute;
  left: 4px;
  top: 4px;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 1px 6px 1px 3px;
  border-radius: 6px;
  pointer-events: none;
}

.ol-file__nome {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  color: #fff;
  background: #4caf50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
}

.ol-file__remover {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ol-file__barra {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ol-file__contagem {
  font-size: 13px;
  color: #78909c;
}

.ol-file__info {
  margin-top: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #eceff1;
  color: #455a64;
  font-size: 13px;
  line-height: 1.4;
}

.ol-file__info-acoes {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 6px;
}

.ol-file__input {
  display: none;
}

.ol-file__sheet {
  background: #fff;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.ol-file__sheet-titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: #4caf50;
  color: #fff;
  font-size: 1.05rem;
  font-weight: 500;
}

.ol-file__sheet-titulo span {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ol-file__opcao {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  font-size: 15px;
  font-weight: 500;
  color: #263238;
  border-bottom: 1px solid #eceff1;
}

.ol-file__opcao:hover {
  background: #f1f8e9;
}

.ol-file__opcao small {
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #78909c;
}

.ol-file__opcao-icone {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #4caf50;
}

.ol-file__opcao-icone--doc {
  background: #607d8b;
}

.ol-file__sheet-acoes {
  display: flex;
  justify-content: flex-end;
  padding: 6px 8px 8px;
}

.compact-message {
  color: #e53935;
  font-size: 12px;
  margin-top: 6px;
  line-height: 1.3;
}
</style>
